module.exports = __webpack_public_path__ + "img/FedEx-black.6e90dae9.png";